module.exports = __webpack_public_path__ + "static/media/MahindravideoMobile.921ccdee.webm";